import { render, staticRenderFns } from "./CustomSelect.html?vue&type=template&id=6e01f9e2&scoped=true&external"
import script from "./CustomSelect.js?vue&type=script&lang=js&external"
export * from "./CustomSelect.js?vue&type=script&lang=js&external"
import style0 from "./CustomSelect.scss?vue&type=style&index=0&id=6e01f9e2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e01f9e2",
  null
  
)

export default component.exports